import React from 'react';
import  '../../styles/Jumbotron.css'
import { Link } from "react-router-dom";
import { Button } from 'react-bootstrap';


export const Jumbotron = () => {
  return (
    <>
    <div className='basic-text-white box-v2 font-resize animate__animated animate__fadeIn' ><strong>BIENVENIDO A UNITY</strong></div>
    <div className="jumbotron jumbotron-fluid animate__animated animate__fadeIn " style={{"background":"black", "color":"white"}}>
      <div className="container">
        <p className='basic-text-white'>EN UNITY ENSEÑAMOS DE FORMA TÉCNICA, CONCEPTUAL, HISTORICA Y EFICAZ. DE FORMA QUE NO SOLO APRENDEMOS UN ARTE MARCIAL, SINO QUE TAMBIÉN DISFRUTAMOS DEL DEPORTE. TENEMOS DIFERENTES INSTRUCTORES SEGÚN LA EDAD Y LOS OBJETIVOS PERSONALES DEL ESTUDIANTE.</p>
          <hr/>
          <p className="lead text-center mt-4" style={{paddingTop:"33px"}}>
          <Link to={ `./programs` }>
              <Button className="fs-2" variant="primary">NUESTROS PROGRAMAS</Button>
          </Link> 
          </p>
      </div>
    </div>
    </>
  );
};
